import React, { useState } from 'react';
import { Button, Drawer, Popconfirm, Table } from 'antd';
import { cloneDeep } from 'lodash';
import {
  // useCreateVehicleTypeMutation,
  // useDeleteVehicleTypeMutation,
  // useUpdateVehicleTypeMutation,
  useVehicleTypesQuery,
  VehicleTypesDocument,
  VehicleTypesQuery,
} from '../../../graphql/datamodel.gen';
import { getClient } from '../../../apollo';
import { capitalizeFirstChar } from '../../../utils/string';
import VehicleNewTypeDrawer from './VehicleNewTypeDrawer';
import { sortBy } from 'lodash';
import VehicleEditTypeDrawer from './VehicleEditTypeDrawer';

interface VehicleTypesDrawerProps {
  visible: boolean;
  onClose: () => any;
}
interface VehicleTypesDrawerViewProps {
  vehicleTypes: VehicleTypesQuery['vehicleTypes'];
  // deleteVehicleType: (id: string) => Promise<boolean>;
  // createVehicleType: (name: string) => Promise<any>;
  // editVehicleType: (id: string, data: { name: string }) => Promise<any>;
}

const VehicleTypesDrawerView: React.FC<VehicleTypesDrawerViewProps> = (
  props: VehicleTypesDrawerViewProps,
) => {
  // const [
  //   newVehicleTypeDrawerVisible,
  //   setNewVehicleTypeDrawerVisible,
  // ] = useState<boolean>(false);
  // const [
  //   editVehicleTypeDrawerVisible,
  //   setEditVehicleTypeDrawerVisible,
  // ] = useState<boolean>(false);
  // const [selectedVehicleType, setSelectedVehicleType] = useState<
  //   VehicleTypesQuery['vehicleTypes'][number]
  // >(undefined);

  const columns = [
    {
      title: 'Tipo',
      dataIndex: 'name',
      key: 'type',
      render: (value) => {
        return capitalizeFirstChar(value);
      },
    },
    // {
    //   title: 'Acciones',
    //   key: 'actions',
    //   width: 120,
    //   render: (value, record: VehicleTypesQuery['vehicleTypes'][number]) => {
    //     return (
    //       <span>
    //         <a
    //           onClick={() => {
    //             setSelectedVehicleType(record);
    //             setEditVehicleTypeDrawerVisible(true);
    //           }}
    //         >
    //           Editar
    //         </a>{' '}
    //         |
    //         <Popconfirm
    //           title={'¿Estás seguro?'}
    //           okText={'Sí'}
    //           cancelText={'No'}
    //           onConfirm={() => {
    //             props.deleteVehicleType(record.id);
    //           }}
    //         >
    //           <a style={{ color: 'red' }}>Eliminar</a>
    //         </Popconfirm>
    //       </span>
    //     );
    //   },
    // },
  ];

  return (
    <>
      {/*<div*/}
      {/*  style={{*/}
      {/*    display: 'flex',*/}
      {/*    flexDirection: 'row',*/}
      {/*    justifyContent: 'flex-end',*/}
      {/*    marginBottom: '2em',*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <Button*/}
      {/*    icon={'plus'}*/}
      {/*    onClick={() => setNewVehicleTypeDrawerVisible(true)}*/}
      {/*  >*/}
      {/*    Crear nuevo tipo*/}
      {/*  </Button>*/}
      {/*</div>*/}
      <Table
        rowKey={(record: VehicleTypesQuery['vehicleTypes'][number]) =>
          record.id
        }
        size={'small'}
        columns={columns}
        dataSource={[...props.vehicleTypes]}
        pagination={false}
      />
      {/*<VehicleNewTypeDrawer*/}
      {/*  visible={newVehicleTypeDrawerVisible}*/}
      {/*  onClose={() => {*/}
      {/*    setNewVehicleTypeDrawerVisible(false);*/}
      {/*  }}*/}
      {/*  // onSubmit={props.createVehicleType}*/}
      {/*/>*/}
      {/*<VehicleEditTypeDrawer*/}
      {/*  visible={editVehicleTypeDrawerVisible}*/}
      {/*  onClose={() => {*/}
      {/*    setEditVehicleTypeDrawerVisible(false);*/}
      {/*    setSelectedVehicleType(undefined);*/}
      {/*  }}*/}
      {/*  onSubmit={props.editVehicleType}*/}
      {/*  vehicleType={selectedVehicleType}*/}
      {/*/>*/}
    </>
  );
};

const VehicleTypesDrawer: React.FC<VehicleTypesDrawerProps> = (
  props: VehicleTypesDrawerProps,
) => {
  const { loading: loadingVehicleTypes, data: dataVehicleTypes } =
    useVehicleTypesQuery({
      client: getClient(),
      fetchPolicy: 'cache-and-network',
    });

  // const [deleteVehicleTypeMut] = useDeleteVehicleTypeMutation({
  //   client: getClient(),
  // });
  //
  // const [createVehicleTypeMut] = useCreateVehicleTypeMutation({
  //   client: getClient(),
  // });
  //
  // const [updateVehicleTypeMut] = useUpdateVehicleTypeMutation({
  //   client: getClient(),
  // });

  // const editVehicleType = async (id: string, data: { name: string }) => {
  //   await updateVehicleTypeMut({
  //     variables: {
  //       id,
  //       name: data.name,
  //     },
  //   });
  // };
  //
  // const createVehicleType = async (name: string) => {
  //   await createVehicleTypeMut({
  //     variables: {
  //       name,
  //     },
  //     update: (proxy, mutationResult) => {
  //       const previousTypes = getClient().readQuery<VehicleTypesQuery>({
  //         query: VehicleTypesDocument,
  //       });
  //
  //       const clone = cloneDeep(previousTypes.vehicleTypes);
  //
  //       getClient().writeQuery({
  //         query: VehicleTypesDocument,
  //         data: {
  //           vehicleTypes: [...clone, mutationResult.data.createVehicleType],
  //         },
  //       });
  //
  //       getClient().queryManager.broadcastQueries();
  //     },
  //   });
  // };
  //
  // const deleteVehicleType = async (id: string): Promise<boolean> => {
  //   const result = await deleteVehicleTypeMut({
  //     variables: {
  //       id,
  //     },
  //     update: (proxy, mutationResult) => {
  //       const previousTypes = getClient().readQuery<VehicleTypesQuery>({
  //         query: VehicleTypesDocument,
  //       });
  //
  //       const clone = cloneDeep(
  //         previousTypes.vehicleTypes.filter(vt => vt.id !== id),
  //       );
  //
  //       getClient().writeQuery({
  //         query: VehicleTypesDocument,
  //         data: {
  //           vehicleTypes: clone,
  //         },
  //       });
  //
  //       getClient().queryManager.broadcastQueries();
  //     },
  //   });
  //
  //   return !!result?.data?.deleteVehicleType?.deleted;
  // };

  let vehicleTypes = dataVehicleTypes?.vehicleTypes || [];

  const sorted = sortBy(vehicleTypes, ['name']);

  return (
    <Drawer
      title={'Tipos de vehiculo'}
      destroyOnClose={true}
      maskClosable={true}
      closable={true}
      width={450}
      visible={props.visible}
      onClose={props.onClose}
    >
      <VehicleTypesDrawerView
        vehicleTypes={sorted}
        // deleteVehicleType={deleteVehicleType}
        // createVehicleType={createVehicleType}
        // editVehicleType={editVehicleType}
      />
    </Drawer>
  );
};

export default VehicleTypesDrawer;
